import {useAuthedQuery} from '../../../../common/hooks/QueryHooks';

interface ScheduledGroups {
	storeName?: string;
	groupCount?: number;
}

interface Progress {
	slotCount?: number;
	announcedCount?: number;
	toNotifyCount?: number;
}

interface ScheduedDataTypes {
	scheduledGroups: ScheduledGroups[];
	progress: Progress;
}

const useScheduleProgress = () => {
	const {data, error} = useAuthedQuery<ScheduedDataTypes>(`enterpriser/application/dashboard`);

	return {data, error};
};

export default useScheduleProgress;
